import { Dialog, Divider, IconButton, Stack, Typography } from "@mui/material";
import { ArrowBack, Close } from "@mui/icons-material";
import { PrivateMainLayout } from "../layout";

interface MobileProps {
  title: string;
  open: boolean;
  onClose: any;
  children: any;
  /** Segunda etapa de fluxo: seta à esquerda do título (ex.: voltar aos dados fitness). */
  onBack?: () => void;
}

export function ScreenMobile({
  title,
  open,
  onClose,
  children,
  onBack,
}: MobileProps) {
  return (
    <Dialog fullScreen open={open} disableScrollLock={true}>
      <PrivateMainLayout noSidebar={true}>
        <Stack
          direction="column"
          alignItems="flex-start"
          width="100%"
          height="100%"
          sx={{ minHeight: 0 }}
        >
          <Stack
            width="100%"
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            pb={1}
            gap={1}
          >
            <Stack
              direction="row"
              alignItems="center"
              spacing={1}
              sx={{ flex: 1, minWidth: 0 }}
            >
              {onBack ? (
                <IconButton
                  size="small"
                  aria-label="Voltar"
                  onClick={onBack}
                  sx={{ color: "neutral1000.main", flexShrink: 0 }}
                >
                  <ArrowBack />
                </IconButton>
              ) : null}
              <Typography
                variant="subtitle2"
                color="neutral700.main"
                fontWeight={600}
                sx={{
                  flex: 1,
                  minWidth: 0,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                {title}
              </Typography>
            </Stack>
            <IconButton
              sx={{ color: "neutral1000.main", flexShrink: 0 }}
              onClick={onClose}
              aria-label="Fechar"
            >
              <Close />
            </IconButton>
          </Stack>
          <Divider sx={{ width: "100%", background: "neutral400.main" }} />
          <Stack
            sx={{
              flex: 1,
              minHeight: 0,
              width: "100%",
              overflow: "auto",
            }}
          >
            {children}
          </Stack>
        </Stack>
      </PrivateMainLayout>
    </Dialog>
  );
}
